import { render, staticRenderFns } from "./tg5.vue?vue&type=template&id=33ea4339&scoped=true&"
import script from "./tg5.vue?vue&type=script&lang=js&"
export * from "./tg5.vue?vue&type=script&lang=js&"
import style0 from "./tg5.vue?vue&type=style&index=0&id=33ea4339&prod&lang=scss&scoped=true&"
import style1 from "./tg5.vue?vue&type=style&index=1&id=33ea4339&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ea4339",
  null
  
)

export default component.exports